import React from 'react'
import { Link } from 'react-router-dom'
import Logo from './../assets/images/era-interiors-logo.png';

const Footer = () => {
  return (
    <>
      {/* Footer Start */}
      <footer className="main-footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* Footer Header Start */}
              <div className="footer-header">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    {/* Footer Logo Start */}
                    <div className="footer-logo">
                      <img src={Logo} alt="" style={{width:'148px'}} />
                    </div>
                    {/* Footer Logo End */}
                  </div>
                  <div className="col-md-6">
                    {/* Footer Social Link Start */}
                    <div className="footer-social-links">
                      <div className="footer-social-link-title">
                        <h3>follow our socials</h3>
                      </div>
                      <ul>
                        <li>
                          <a target="_blank" href="https://www.facebook.com/erainteriors15/">
                            <i className="fa-brands fa-facebook-f" />
                          </a>
                        </li>
                        <li>
                          <a target="_blank" href="https://share.google/K5K3ufl6kFuUa49eR">
                            <i className="fa-brands fa-dribbble" />
                          </a>
                        </li>
                        <li>
                          <a target="_blank" href="https://www.instagram.com/erainteriors59/?hl=en">
                            <i className="fa-brands fa-instagram" />
                          </a>
                        </li>
                      </ul>
                    </div>
                    {/* Footer Social Link End */}
                  </div>
                </div>
              </div>
              {/* Footer Header End */}
            </div>
            <div className="col-lg-3 col-md-6">
              {/* Footer Links Start */}
              <div className="footer-links">
                <h3>information</h3>
                <ul>
                  <li>
                    <Link to="/about-us">about our company</Link>
                  </li>
                  <li>
                    <Link to="/services">view our service</Link>
                  </li>
                  <li>
                    <Link to="#">careers at company</Link>
                  </li>
                  <li>
                    <Link to="#">read our blog</Link>
                  </li>
                  <li>
                    <Link to="#">our latest projects</Link>
                  </li>
                </ul>
              </div>
              {/* Footer Links End */}
            </div>
            <div className="col-lg-3 col-md-6">
              {/* Footer Links Start */}
              <div className="footer-links">
                <h3>portfolio</h3>
                <ul>
                  <li>
                    <Link to="#">luxury home design</Link>
                  </li>
                  <li>
                    <Link to="#">residential interior design</Link>
                  </li>
                  <li>
                    <Link to="#">commercial space design</Link>
                  </li>
                  <li>
                    <Link to="#">residential interior design</Link>
                  </li>
                  <li>
                    <Link to="#">
                      renovation and restoration design
                    </Link>
                  </li>
                </ul>
              </div>
              {/* Footer Links End */}
            </div>
            <div className="col-lg-3 col-md-6">
              {/* Footer Contact Box Start */}
              <div className="footer-contact-box footer-links">
                <h3>contact us</h3>
                {/* Footer Contact Item Start */}
                <div className="footer-contact-item">
                  <div className="icon-box">
                    <i className="fa-solid fa-phone" />
                  </div>
                  <div className="footer-contact-content">
                    <p>+91 8830219839</p>
                  </div>
                </div>
                {/* Footer Contact Item End */}
                {/* Footer Contact Item Start */}
                <div className="footer-contact-item">
                  <div className="icon-box">
                    <i className="fa-solid fa-envelope" />
                  </div>
                  <div className="footer-contact-content">
                    <p>enquiry@erainterior.in</p>
                  </div>
                </div>
                {/* Footer Contact Item End */}
                {/* Footer Contact Item Start */}
                <div className="footer-contact-item">
                  <div className="icon-box">
                    <i className="fa-solid fa-location-dot" />
                  </div>
                  <div className="footer-contact-content">
                    <p>Shop no : 2, Shyama Apartment, Pratap Nagar, Nagpur, Maharashtra.Pin code: 440022</p>
                  </div>
                </div>
                {/* Footer Contact Item End */}
              </div>
              {/* Footer Contact Box End */}
            </div>
            <div className="col-lg-3 col-md-6">
              {/* Footer Newsletter Form Start */}
              <div className="footer-latest-news footer-links">
                <h3>get the latest trending news</h3>
                <div className="footer-newsletter-form">
                  <p>
                    Your Dream Space Starts Here Get Exclusive Design Straight Your
                    Inbox!
                  </p>
                  <form id="newslettersForm" action="#" method="POST">
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        id="mail"
                        placeholder="Enter your email"
                        required=""
                      />
                      <button type="submit">
                        <i className="fa-solid fa-arrow-right-long" />{" "}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* Footer Newsletter Form End */}
            </div>
          </div>
          {/* Footer Copyright Section Start */}
          <div className="footer-copyright">
            <div className="row">
              <div className="col-md-12">
                {/* Footer Copyright Start */}
                <div className="footer-copyright-text">
                  <p>Copyrights © {(new Date().getFullYear())}. All rights reserved by{" "} ERA Interiors.</p>
                </div>
                {/* Footer Copyright End */}
              </div>
            </div>
          </div>
          {/* Footer Copyright Section End */}
        </div>
      </footer>
      <a
        href="https://wa.me/918830219839"
        className="whatsapp-float"
        target="_blank"
        rel="noopener"
      >
        <img
          src="https://img.icons8.com/color/48/000000/whatsapp--v1.png"
          alt="WhatsApp"
        />
      </a>
    </>
  )
}

export default Footer
